import { createCalendar } from "@internationalized/date";
import { useDateFieldState } from "@react-stately/datepicker";
import cx from "classnames";
import { type FC, useRef } from "react";
import { type AriaDatePickerProps, type DateValue, useDateField, useLocale } from "react-aria";

import { DateSegment } from "../InputDate/DateSegment";

export const InputDateBare: FC<
	AriaDatePickerProps<DateValue> & {
		datePickerDialogTrigger: "manual" | "click";
		triggerDatePickerDialog: () => void;
		constantWidthDateSegments: boolean;
	}
> = (props) => {
	const { locale } = useLocale();
	const state = useDateFieldState({
		...props,
		locale,
		createCalendar,
	});

	const ref = useRef<HTMLDivElement>(null);
	const { fieldProps } = useDateField(props, state, ref);

	return (
		<div {...fieldProps} className={cx("flex")}>
			{state.segments.map((segment, i) => (
				<DateSegment
					key={i}
					segment={segment}
					state={state}
					datePickerDialogTrigger={props.datePickerDialogTrigger}
					triggerDatePickerDialog={props.triggerDatePickerDialog}
					constantWidth={props.constantWidthDateSegments}
				/>
			))}
		</div>
	);
};
